import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-integration',
  templateUrl: './integration.component.html',
  styleUrls: ['./integration.component.scss'],
})
export class IntegrationComponent implements OnInit {
  public config = null;
  public queryParams = null;

  constructor(private route: ActivatedRoute) {
    this.config = this.route.snapshot.data.resolved;
    this.queryParams = {
      iframeMode: this.route.snapshot.queryParams.iframeMode,
      viewId: this.route.snapshot.queryParams.view_id,
      siteId: this.route.snapshot.params.site,
      fov: this.route.snapshot.queryParams.fov,
    };
    localStorage.removeItem('view_id');
  }

  ngOnInit(): void {}
  
}
